<div class="filter" *ngIf="config.options.length > 0 && config.category != 'Meal' && config.category != 'PaymentAndBooking'">
  <div class="filter-name" *ngIf="config.options.length > 0">{{config.name}}:</div>
  <div class="filter-list-wrapper" [ngClass]="{'show-less' : !showMore}">
    <div *ngFor="let option of config.options; let i=index;" class="filter-list">
      <ng-container *ngIf="config.type==='list' && config.category != 'Meal' && config.category != 'PaymentAndBooking'">
        <div class="material-checkbox">
          <input id="option{{i}}{{config.category}}" type="checkbox" value="option.value"
            [(ngModel)]="option['checked']" (change)="checked($event, config)">
          <label for="option{{i}}{{config.category}}">{{option.label}}</label>
        </div>
        <div class="no-of-results">
          ({{option.count}})
        </div>
      </ng-container>
      <!-- <ng-container *ngIf="config.type==='range'">
        <div class="material-checkbox">
          <input id="option{{i}}{{config.category}}" type="checkbox" value="option.value"
            [(ngModel)]="option['checked']" (change)="checked($event, config)">
          <label for="option{{i}}{{config.category}}">{{option.label}}</label>
        </div>
        <div class="no-of-results">
          ({{option.count}})
        </div>
      </ng-container> -->
    </div>
  </div>
  <div *ngIf="config?.options?.length > 6" class="show-more-less">
    <span (click)="toggleDisplay();">{{showMoreText}}</span>
  </div>
</div>
